import { render, staticRenderFns } from "./ModalRevisarDados.vue?vue&type=template&id=073f5eb4&scoped=true"
import script from "./ModalRevisarDados.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalRevisarDados.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ModalRevisarDados.vue?vue&type=style&index=0&id=073f5eb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073f5eb4",
  null
  
)

export default component.exports